export const CHAT_API_URL = "/api/chat";
/** Multipart BRD upload: same chat semantics as POST /chat with server-side text extraction */
export const CHAT_DOCUMENT_API_URL = "/api/chat/document";
export const CLEAR_CHAT_API_URL = "/api/clear_chat";
export const SAVE_ESTIMATION_API_URL = "/api/save_estimation_items";
export const DASHBOARD_ESTIMATIONS_API_URL = "/api/dashboard/estimations";
export const CHAT_HISTORY_API_URL = "/api/chat/history";

export const AUTH_UPDATE_PROFILE_API_URL = "/api/auth/update-profile";
export const AUTH_ME_API_URL = "/api/auth/me";
export const ADMIN_USERS_ESTIMATIONS_API_URL = "/api/admin/users/estimations";
export const ADMIN_ALL_USERS_API_URL = "/api/admin/users/all";
export const ADMIN_USER_API_URL = "/api/admin/users";

// Increased timeout for long-running requests like module & feature wise estimation
export const REQUEST_TIMEOUT_MS = 7200000; // 2 hours
export const APP_NAME = "Concetto Estimator";

export const SUPER_ADMIN_EMAIL = "admin@concettolabs.com";

// Matches backend SESSION_TTL: sessions in Redis expire after this many hours
export const SESSION_TTL_HOURS = 4;

export const STORAGE_KEYS = {
  SESSION_ID: "cettomate_session_id",
  DASHBOARD_OWNER_ID: "cettomate_dashboard_owner_id",
  USER: "cettomate_user",
  ACCESS_TOKEN: "cettomate_access_token",
};
